<template>
  <div ref="qrcodeContainer"></div>
</template>

<script>
// import QRCode from "qrcodejs2"
import QRCode from "qrcodejs2-fix"
import { mixinsCom } from "@/mixins/globalAllComps";
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data"
export default {
  name: "cpt-qrcode",
  props: {
    option: Object,
    refMap: Object,
    current: Object,
  },
  mixins: [mixinsCom],
  data() {
    return {
      // iptVal:"",
      // newData: "",
      // jsFunFlag: false,
      uuid: null,
      qrcodeInstance: null,
    };
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "option.attribute": {
      handler() {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptWidth": {
      handler() {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptHeight": {
      handler() {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  mounted() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      if (this.option.cptDataForm.resData) {
        this.processData(this.option.cptDataForm, this.option.cptDataForm.resData, this.option.cptDataForm.jsFunFlag);
      } else {
        this.refreshCptData();
      }
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        // that.processData(cptDataForm, that.newData, that.jsFunFlag);   //监听里面会执行的
      });
    },
    processData(cptDataForm, res, jsFunFlag) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.iptVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = this.newData;
      }
      this.init();
    },
    init() {
      try {
        // 如果改变宽高颜色，文本内容，要叠加生成，所以要清空
        const element = this.$refs.qrcodeContainer;
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
        const correctLevel = this.getCorrectLevel();
        this.qrcodeInstance = new QRCode(element, {
          text: this.iptVal,
          width: this.current.cptWidth,
          height: this.current.cptHeight,
          colorDark: this.option.attribute.bgColor, // 暗色模块颜色（通常代表二维码的黑色部分）
          colorLight: this.option.attribute.qrColor, // 亮色模块颜色（通常代表二维码的背景色）
          correctLevel,
        });
      } catch(err) {
        console.error(err)
      }
    },
    getCorrectLevel() {
      const qrLevel = this.option.attribute.qrLevel

      let correctLevel;
      switch (qrLevel) {
        case 'L':
          correctLevel = QRCode.CorrectLevel.L;
          break;
        case 'M':
          correctLevel = QRCode.CorrectLevel.M;
          break;
        case 'Q':
          correctLevel = QRCode.CorrectLevel.Q;
          break;
        case 'H':
          correctLevel = QRCode.CorrectLevel.H;
          break;
        default:
          console.warn('Invalid qrLevel value, using L as default.');
          correctLevel = QRCode.CorrectLevel.L;
      }

      return correctLevel;
    },
  },
};
</script>

<style></style>